import { useCallback } from 'react';

export const useLocalStorage = (
  key: string,
  isObject: boolean = false,
  defaultValue: any = null
): [any, (value: any) => void] => {
  const localStorageValue = localStorage.getItem(key);

  const parsedValue =
    isObject && typeof localStorageValue === 'string'
      ? JSON.parse(localStorageValue)
      : localStorageValue;

  const handleUpdateLocalStorage = useCallback(
    (value: any) => {
      localStorage.setItem(key, isObject ? JSON.stringify(value) : value);
    },
    [key, isObject]
  );

  return [parsedValue || defaultValue, handleUpdateLocalStorage];
};
